import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const TypedText = ({
  text,
  className = "",
  delay = 0,
  // typing speed in ms per character (larger = slower)
  speed = 120,
  cursorColor = "#fbbf24",
  isActive = true, // خاصية جديدة لتحديد إذا السلايد نشط
  onComplete,
}) => {
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    // Reset when text changes OR when slide becomes active
    if (isActive) {
      setDisplayText("");
      setCurrentIndex(0);
      setIsComplete(false);

      const startTimeout = setTimeout(() => {
        const interval = setInterval(() => {
          setCurrentIndex((prev) => {
            if (prev < text.length) {
              setDisplayText(text.slice(0, prev + 1));
              return prev + 1;
            } else {
              clearInterval(interval);
              setIsComplete(true);
              if (onComplete) onComplete();
              return prev;
            }
          });
        }, speed);

        return () => clearInterval(interval);
      }, delay);

      return () => clearTimeout(startTimeout);
    } else {
      // Reset when slide becomes inactive
      setDisplayText("");
      setCurrentIndex(0);
      setIsComplete(false);
    }
  }, [text, delay, speed, isActive, onComplete]);

  if (!isActive) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span className={`inline-block ${className}`}>
      {displayText}
      {!isComplete && (
        <motion.span
          animate={{ opacity: [1, 0] }}
          transition={{ duration: 0.5, repeat: Infinity }}
          className="inline-block w-0.5 h-6 ml-1 align-middle"
          style={{ backgroundColor: cursorColor }}
        />
      )}
    </span>
  );
};

export default TypedText;
